import { mapSearchPlacesGetAction } from "./action";
import { combineReducers } from "redux";
import { createReducer } from "typesafe-actions";
import createLoadingReducer from "../../libraries/packages/redux-utils/src/request/create-loading-reducer";
import createErrorReducer from "../../libraries/packages/redux-utils/src/request/create-error-reducer";
import createOperationReducer from "../../libraries/packages/redux-utils/src/request/create-operation-reducer";
import { paginationReducer } from "../../libraries/packages/redux-utils/src/request/pagination/usePagination";
export const mapSearchPlacesReducer = combineReducers<{
  data: any;
  lastOpId: string | null;
  isLoading: Set<string>;
  error: Error;
}>({
  data: createReducer(null).handleAction(
    [mapSearchPlacesGetAction.success],
    paginationReducer((it) => it.place_id, {
      listSelector: (data) => data.data,
      metaSelector: (data) => data.meta,
      offsetField: "offset",
    })
  ),
  isLoading: createLoadingReducer(mapSearchPlacesGetAction),
  lastOpId: createOperationReducer(mapSearchPlacesGetAction),
  error: createErrorReducer(mapSearchPlacesGetAction),
});
